"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SchemaProps = _interopRequireDefault(require("../SchemaProps"));

var _CountryStateKeyword = _interopRequireDefault(require("../CountryStateKeyword"));

var _ProductInterestKeyword = _interopRequireDefault(require("../ProductInterestKeyword"));

var _UTMMediumKeyword = _interopRequireDefault(require("../UTMMediumKeyword"));

var _ajv = _interopRequireDefault(require("ajv"));

var _ajvErrors = _interopRequireDefault(require("ajv-errors"));

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BaseValidator =
/*#__PURE__*/
function () {
  function BaseValidator(type, mkto) {
    var stateRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    _classCallCheck(this, BaseValidator);

    this.mkto = mkto;
    this.stateRequired = stateRequired;
    this.ajv = (0, _ajvErrors.default)(new _ajv.default({
      allErrors: true,
      jsonPointers: true,
      verbose: false
    }));
    this.validator = null;
    this.props = {};
    this.type = type;
    this.schema_props = (0, _SchemaProps.default)(this.mkto); // Default required fields (these are required by all types)
    // Children Validators will append additional fields

    this.required = ["email", "InteractionStage", "programName"];
    this.required = mkto === "legacy" ? _toConsumableArray(this.required).concat(["ctx_RecordProcessingType", "PrimaryProductInterest", "RegistrationDate"]) : _toConsumableArray(this.required).concat(["Record_Processing_Type__c", "Primary_Product_Interest__c", "Registration_Date__c"]);
    this.schema_template = {
      "$schema": "http://json-schema.org/draft-07/schema#",
      "$id": "http://citrix.com/mktg/schemas/lead-intake-".concat((0, _util.camel2kebab)(type)),
      "type": "object",
      "errorMessage": {}
    };
  }
  /**
   * Initialize schema, this happens after the constructor runs to set up the validator
   * options in the Children Implementations
   * @private
   */


  _createClass(BaseValidator, [{
    key: "_init",
    value: function _init() {
      //populate required fields
      this.schema_template.required = this._makeRequired(); //populate properties

      this.schema_template.properties = this._makeProps(); //populate required errors (this has to come after properties)

      this.schema_template.errorMessage = this._makeErrorMessages(); //add custom keyword to AJV instance & keyword to schema

      this.ajv.addKeyword("CountryState", _CountryStateKeyword.default);
      var isCountryRequired = this.required.includes['country'];
      this.schema_template.CountryState = {
        required: isCountryRequired,
        stateRequired: this.stateRequired,
        mkto: this.mkto //add custom keyword to AJV instance & keyword to schema

      };
      this.ajv.addKeyword("PrimaryProductInterestList", _ProductInterestKeyword.default);
      this.schema_template.PrimaryProductInterestList = {
        mkto: this.mkto //add custom keyword to AJV instance & keyword to schema

      };
      this.ajv.addKeyword("UTMMedium", _UTMMediumKeyword.default);
      this.schema_template.UTMMedium = {
        mkto: this.mkto //compile schema

      };
      this.validator = this.ajv.compile(this.schema_template);
    }
    /**
     * filter out all the errors and flatten them into something digestable
     * * @private
     */

  }, {
    key: "_processErrors",
    value: function _processErrors() {
      var errors = [];
      console.log('!!'.repeat(10));
      console.log(this.validator.errors);
      console.log('!!'.repeat(10)); //get all required into a flat list

      var requiredErrors = this.validator.errors.filter(function (e) {
        return e.keyword === 'required';
      }).map(function (e) {
        return e.params.missingProperty;
      });

      if (requiredErrors.length > 0) {
        errors.push("Lead type '".concat(this.type, "' requires: ").concat(requiredErrors.join(', ')));
      } //merge all custom error messages


      var errorFilter = ['errorMessage', 'CountryState', 'PrimaryProductInterestList', 'UTMMedium'];
      this.validator.errors.filter(function (e) {
        return errorFilter.includes(e.keyword);
      }).forEach(function (e) {
        return errors.push(e.message);
      });
      return errors;
    }
    /**
     * Execute the validation, return result and errors (if there are any)
     */

  }, {
    key: "validate",
    value: function validate(record) {
      var result = this.validator(record);

      if (!result) {
        var errors = this._processErrors();

        return {
          result: result,
          errors: errors,
          type: this.type
        };
      }

      return {
        result: result,
        type: this.type
      };
    }
  }, {
    key: "schema",
    value: function schema() {
      return this.schema_template;
    }
    /**
     * Create the error message part of the schema
     * @private
     */

  }, {
    key: "_makeErrorMessages",
    value: function _makeErrorMessages() {
      var _this = this;

      var propErrorMsgs = {};
      Object.keys(this.props).forEach(function (p) {
        if (_this.props[p].error) {
          propErrorMsgs[p] = _this.props[p].error;
          return;
        }

        if (_this.props[p].maxLength) {
          propErrorMsgs[p] = "'".concat(p, "' is too long should be no longer than ").concat(_this.schema_props[p].maxLength, " characters.");
          return;
        }
      });
      return {
        properties: propErrorMsgs
      };
    }
    /**
     * Create the required part of the schema
     * @private
     */

  }, {
    key: "_makeRequired",
    value: function _makeRequired() {
      return this.required;
    }
    /**
     * Create the properties part of the schema allows sub classes to provide overrides
     * @private
     */

  }, {
    key: "_makeProps",
    value: function _makeProps() {
      this.props = _objectSpread({}, this.schema_props, this.props);
      return this.props;
    }
  }]);

  return BaseValidator;
}();

exports.default = BaseValidator;
//# sourceMappingURL=BaseValidator.js.map